import { createEntity } from "./api";
import { toast } from "sonner";
import { useMutation } from "@tanstack/react-query";
import { invalidateAllQueries } from "utils/utils";

function buildPayload(values) {
    if (!values || typeof values !== "object") return {};

    const { organisation, ...rest } = values;

    let organisationId;
    if (typeof organisation === 'string') {
        organisationId = organisation;
    } else if (organisation?.id) {
        organisationId = organisation.id;
    }

    const payload = {
        ...Object.fromEntries(
            Object.entries(rest).filter(
                ([_, v]) => v !== "" && v !== undefined && v !== null
            )
        ),
        organisation: organisationId,
    };
    return payload;
}

export function useCreateEntity() {
    return useMutation({
        mutationFn: async ({ values }) => {
            const payload = buildPayload(values);

            try {
                const response = await createEntity({ item: payload });
                return response;
            } catch (error) {
                throw error;
            }
        },
        onSuccess: () => {
            toast.success("Entity Created Successfully");
            invalidateAllQueries();
        },
        onError: (error) => {
            toast.error(error.message);
            console.log(error.message);
        },
    });
}
